namespace $.$$ {

	$mol_style_define( $hyoo_intern_cabinet_mentor, {

		Profile: $hyoo_intern_cabinet_page_style,
		Company_page: $hyoo_intern_cabinet_page_style,
		Vacancy_page: $hyoo_intern_cabinet_page_style,

	 } )

}
